/* eslint-disable no-useless-concat */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Block, LoadingComponent, PreviewAltCard } from "../../../components/Component";
import { ShiftCheck } from "../../../utils";
import { useEffect } from "react";
import { availbilityDateListApi } from "./AvailbilityData";
import CalenderApp from "../../../components/partials/calender/Calender";
import AddAvailbility from "./AddAvailbility";
import moment from "moment";
import {
  UserActionType,
  UserPermissionType,
  isAllowToAccess,
  isCheckToList,
} from "../../../services/permission/permission";
import { convertHexToColor } from "../../../utils/Functions";
const Availbility = ({ carerId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [initScreen, setInitScreen] = useState(true);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedAwayReason, setSelectedAwayReason] = useState();
  const [modal, setModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [availbilityDateList, setAvailbilityDateList] = useState([]);
  const [availbilityEvent, satAvailbilityEvent] = useState([]);

  // const getStatusColor = (status) => {
  //   switch (status) {
  //     case TimesheetStatusType.pending:
  //       return "danger";
  //     case TimesheetStatusType.submitted:
  //       return "warning";
  //     case TimesheetStatusType.verified:
  //       return "success";
  //     default:
  //       return null;
  //   }
  // };

  const createBookedEvent = (item, index, objectAvail) => {
    const booking = item.bookedData[0];
    const bookedStartTime = moment(booking.startTime, "HH:mm:ss").format("HH:mm");
    const bookedEndTime = moment(booking.endTime, "HH:mm:ss").format("HH:mm");
    const bookedTitle = `<div style="overflow: hidden; text-overflow: ellipsis; max-width: 100%;">${booking.clientName}<br>${bookedStartTime}-${bookedEndTime}</div>`;

    // const statusColor = getStatusColor(booking?.timesheetStatus);
    let eventClassName;

    // if (statusColor) {
    //   eventClassName = `fc-event-${statusColor}`;
    // } else {
    const gradeColor = convertHexToColor(booking?.grade?.colourHex);
    eventClassName =
      gradeColor && gradeColor !== "undefined" && gradeColor !== null ? `fc-event-${gradeColor}` : "fc-event-danger";
    // }

    return {
      id: "booked-" + `${index + 1}`,
      title: bookedTitle,
      objects: objectAvail,
      start: moment(item?.availableDate).format("YYYY-MM-DD HH:mm:ss"),
      end: moment(item?.availableDate).add(1, "hours").format("YYYY-MM-DD HH:mm:ss"),
      className: eventClassName,
      awayReason: item?.awayReason,
      isBooked: true,
      isTraining: false,
      bookedData: item.bookedData,
      gradeColor: booking?.grade?.colourHex,
    };
  };
  const createTrainingEvent = (item, index, objectAvail) => {
    const training = item.trainingData[0];
    const trainingStartTime = moment(training.startTime, "HH:mm:ss").format("HH:mm");
    const trainingEndTime = moment(training.endTime, "HH:mm:ss").format("HH:mm");
    const trainingTitle = `${training.title}<br>${trainingStartTime}-${trainingEndTime}`;
    return {
      id: "training-" + `${index + 1}`,
      title: trainingTitle,
      objects: objectAvail,
      start: moment(item?.availableDate).format("YYYY-MM-DD HH:mm:ss"),
      end: moment(item?.availableDate).add(1, "hours").format("YYYY-MM-DD HH:mm:ss"),
      className: "fc-event-pink",
      awayReason: item?.awayReason,
      isBooked: false,
      isTraining: true,
      trainingData: item.trainingData,
    };
  };
  const createAvailabilityEvent = (item, index, objectAvail, dayAvail) => {
    let eventClassName;
    if (objectAvail.some((item) => item.value === "is_any")) {
      eventClassName = "fc-event-success";
    } else if (objectAvail.some((item) => item.value === "is_night")) {
      eventClassName = "fc-event-primary";
    } else if (objectAvail.some((item) => item.value === "is_away_period")) {
      eventClassName = "fc-event-warning";
    } else {
      eventClassName = "fc-event-orange";
    }
    return {
      id: "default-" + `${index + 1}`,
      title: dayAvail.join(", "),
      objects: objectAvail,
      start: moment(item?.availableDate).format("YYYY-MM-DD HH:mm:ss"),
      end: moment(item?.availableDate).add(1, "hours").format("YYYY-MM-DD HH:mm:ss"),
      className: eventClassName,
      awayReason: item?.awayReason,
      isBooked: false,
      isTraining: false,
    };
  };
  useEffect(() => {
    if (startDate && endDate) callAvailbilityDateListApi();
  }, [endDate]);
  useEffect(() => {
    let eventList = [];
    availbilityDateList.forEach((item, index) => {
      let objectAvail = [];
      let dayAvail = [];
      item?.availableFor.forEach((object, index) => {
        let findItem = ShiftCheck?.find((shiftTimeItem) => object === shiftTimeItem.value);
        if (findItem) {
          objectAvail.push(findItem);
          dayAvail.push(findItem?.label);
        }
      });
      const hasBookedData = item.bookedData && item.bookedData.length > 0;
      const hasTrainingData = item.trainingData && item.trainingData.length > 0;
      if ((hasBookedData && hasTrainingData) || hasBookedData) {
        eventList.push(createBookedEvent(item, index, objectAvail));
      } else if (hasTrainingData) {
        eventList.push(createTrainingEvent(item, index, objectAvail));
      } else {
        eventList.push(createAvailabilityEvent(item, index, objectAvail, dayAvail));
      }
      satAvailbilityEvent(eventList);
    });
    satAvailbilityEvent(eventList);
  }, [availbilityDateList]);
  useEffect(() => {
    if (initScreen) return;
    if (currentPage === 1) {
      // loadClientNote();
    } else {
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);
  const addEvent = (info) => {
    // Check if the clicked date already has a booked or training event
    const clickedDate = moment(info.date).format("YYYY-MM-DD");
    const existingEvent = availbilityEvent.find((event) => {
      const eventDate = moment(event.start).format("YYYY-MM-DD");
      return eventDate === clickedDate && (event.isBooked || event.isTraining);
    });

    // If date already has a booked/training event, don't allow adding new events
    if (existingEvent) {
      return;
    }
    setSelectedDate(info.date);
    setModal(true);
  };
  const onEventClick = (info) => {
    // Don't allow editing if event is booked or training
    if (info._def.extendedProps?.isBooked || info._def.extendedProps?.isTraining) {
      return;
    }
    setSelectedDate(moment(info._instance?.range?.start).format("YYYY-MM-DD"));
    setSelectedItem(info._def.extendedProps?.objects);
    setSelectedAwayReason(info._def.extendedProps?.awayReason);
    setModal(true);
  };
  const callAvailbilityDateListApi = () => {
    if (!startDate || !endDate) return;
    if (isCheckToList(UserPermissionType.availability)) {
      let params = {
        carerId: carerId,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
      };
      availbilityDateListApi(params, (data, error) => {
        if (error === null) {
          setAvailbilityDateList(data.list);
        }
        setInitScreen(false);
      });
    } else {
      setInitScreen(false);
    }
  };
  return (
    <React.Fragment>
      <div className="py-4 px-4 px-xxl-0">
        {isCheckToList(UserPermissionType.availability) ? (
          <CalenderApp
            events={availbilityEvent}
            onDelete={"deleteEvent"}
            onEdit={"onEdit"}
            onAdd={isAllowToAccess(UserPermissionType.availability, UserActionType.setavailability) ? addEvent : null}
            onEvent={
              isAllowToAccess(UserPermissionType.availability, UserActionType.setavailability) ? onEventClick : null
            }
            onDateChange={(start, end) => {
              setStartDate(start);
              setEndDate(end);
            }}
            editable={true}
            eventEditable={(eventInfo) => {
              // Only allow editing if event is NOT booked or training
              return !(eventInfo.extendedProps?.isBooked || eventInfo.extendedProps?.isTraining);
            }}
          />
        ) : (
          <Block className={"pt-1"}>
            <PreviewAltCard>
              <span className="d-flex justify-content-center">You do not have permission</span>
            </PreviewAltCard>
          </Block>
        )}
      </div>

      <AddAvailbility
        visible={modal}
        carerId={carerId}
        start_Date={selectedDate}
        item={selectedItem}
        awayReason={selectedAwayReason}
        onClosed={() => {
          setModal(false);
          setSelectedItem();
          setSelectedAwayReason();
          setSelectedDate();
        }}
        onSaved={() => {
          callAvailbilityDateListApi();
        }}
      />
      <LoadingComponent isLoading={initScreen} />
    </React.Fragment>
  );
};
export default Availbility;
